const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/envelope-papers`,
    search: `${API_URL}/envelope-paper/search`,
    information: `${API_URL}/envelope-paper/information`
};

export default apiUrls;
